import { render, staticRenderFns } from "./UpLoad.vue?vue&type=template&id=0bb76e0c&scoped=true"
import script from "./UpLoad.vue?vue&type=script&lang=js"
export * from "./UpLoad.vue?vue&type=script&lang=js"
import style0 from "./UpLoad.vue?vue&type=style&index=0&id=0bb76e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb76e0c",
  null
  
)

export default component.exports